import React from 'react';
import { connect, getIn } from 'formik';
import Radio from 'components/inputs/Radio';

const RadioField = connect(
  ({
    name,
    formik: { values, errors, touched, handleChange, handleBlur, ...formik },
    ...props
  }: any) => {
    const getInValue = getIn(values, name);
    const v = isNaN(getInValue) ? getInValue : parseInt(getInValue);

    return <Radio name={name} value={v} {...props} onChange={handleChange} />;
  }
);

export default RadioField;
